module.exports = __webpack_public_path__ + "static/assets/c8137fca145c9073dbe21640c28ae24b.svg";